import React, { useEffect, useState } from "react";
import { baseURL } from "../../constants/Api";
import axios from "axios";
import { Link } from "react-router-dom";
import BottonToggle from "../bars/BottomToggle";
import Skeleton from "../../components/skeletons/skeleton";
import ProfileIcon from "../../components/ProfileIcon";
import Logoheader from "../../components/Logoheader";
import EventList from "./EventList";
import { fetch_all_events } from "../../actions/events/event";
import { ExplorePageView } from "../../utils/Analytics";

function Explore() {
  const [loading, setLoading] = useState(false);
  const [hotelArray, setHotelArray] = useState([]);
  const[eventList, setEventList] = useState([])
  const fetchHotels = async () => {
    setLoading(true);
    try {
      await axios({
        method: "get",
        url: `${baseURL}/api/listHotels`,

        headers: { "Content-Type": "application/json" },
      }).then(function (response) {
        var hotels = response.data.data;
        const filteredArray = hotels.filter((item) => {
          return (
            item.name.toLowerCase() && ![1, 2, 14, 15, 16].includes(item.id) && item?.isApproved 
          );
        });
        setHotelArray(filteredArray);
      });
    } catch {}
    setLoading(false);
  };


  const fetchEvents = async()=>{
    try{
        const res = await fetch_all_events()
        console.log(res)
        if(res.data?.success){
            setEventList(res.data?.data)
            console.log(res.data?.data)
        }
    }catch(e){
        console.log(e)
    }
  }

  useEffect(() => {
    ExplorePageView();
    fetchHotels();
    fetchEvents();
  }, []);

  
 
  
  return (
    <div>
      {!loading ? (
        <div>
          <Logoheader/>
          <BottonToggle />
         
          <div className="explore-page section-wrap py-10 pt-3 relative">
            <ProfileIcon />
            <div className="head mb-3">Explore</div>
            {eventList?.length > 0 && <EventList eventList={eventList}/>}
            <div className="sub-head mb-4">Recommended Hotels</div>
            <div className="grid grid-flow-row lg:grid-cols-4 grid-cols-2  gap-5 lg:mt-6 mt-3 pb-32">
              {hotelArray.map((item, i) => (
                <a
                  key={i}
                  href={`${baseURL}/hotel-details/${item.id}/${item.slug}`}
                  // to={"../hotel-detail/" + item.slug + -+item.id}
                  state={item.id}
                  className="flex flex-col"
                >
                  <div
                    className="hotel-img sm:h-40 h-28 w-full"
                    style={{
                      background:
                        item.images.length !== 0
                          ? `url(${item.images[0]})`
                          : "gray",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  ></div>
                  <div className="name mt-2">{item.name}</div>
                  <div className="place">{item.city}</div>
                </a>
              ))}
            </div>
          </div>
        </div>
      ) : (
        <Skeleton type="page" />
      )}
    </div>
  );
}

export default Explore;
